import auth from './controllers/auth';
import media from './controllers/media';
import projects from './controllers/projects';
import marks from './controllers/marks';
import scenes from './controllers/scenes';

export const API_URLS = {
  DEV: 'http://localhost:3000/api/',
  PROD: '/api/',
};

export const BASE_URL = API_URLS['PROD'];

export default {
  auth: auth(BASE_URL),
  media: media(BASE_URL),
  projects: projects(BASE_URL),
  marks: marks(BASE_URL),
  scenes: scenes(BASE_URL),
};
